/**
 * Catch-all 404 inside the gated shell: a styled state with a way home that names itself in
 * `document.title` (TMMRSL-0043). Always an `h1` with `page · console` (TMMRSL-0058).
 */
import { useEffect } from 'react';
import { Box, Link, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { HOME_PATH } from '@/routes/home';

export function NotFound() {
  const { t } = useTranslation();
  const title = t('errors.notFoundTitle');
  const consoleName = t('app.consoleName');

  useEffect(() => {
    document.title = [title, consoleName].filter(Boolean).join(' · ');
  }, [title, consoleName]);

  return (
    <Box component="section">
      <Typography variant="h1" component="h1" sx={{ mb: 1 }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
        {t('errors.notFoundBody')}
      </Typography>
      <Link component={RouterLink} to={HOME_PATH}>
        {t('errors.goHome')}
      </Link>
    </Box>
  );
}
